// extracted by mini-css-extract-plugin
module.exports = {"menuWrapper":"Menu_menuWrapper__aY014","logoWrapper":"Menu_logoWrapper__3qgdq","menuCategory":"Menu_menuCategory__2G-WX","categoryTitle":"Menu_categoryTitle__1tR1_"};